import { InMemoryCache } from '@apollo/client';
import { GET_CREATE_PROFILE_UPLOADED_PHOTO } from 'graphqls/media';

const defaultCreateProfileUploadedPhoto = null;

export const initializeCreateProfileUploadedPhotoState = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_CREATE_PROFILE_UPLOADED_PHOTO,
    data: {
      createProfileUploadedPhoto: defaultCreateProfileUploadedPhoto,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      editCreateProfileUploadedPhoto: (_, { media }, { cache }) => {
        cache.writeQuery({
          query: GET_CREATE_PROFILE_UPLOADED_PHOTO,
          data: {
            createProfileUploadedPhoto: media,
          },
        });
        return media;
      },
    },
  },
};
